import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { postService, utilService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import { Pagination, Score, Panel } from '../../../atoms'
import * as interfaces from '../../../../static/interfaces'

import AvatarImage from 'components/atoms/AvatarImage'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  reviews: {
    records: IJsonResponse
  }
  user: any
  tours_average_review: number
  tours_review_count: number
}

interface IReview {
  body: string
  id: number
  rating: number
  rating_friendliness: number
  rating_hospitality: number
  rating_informative: number
  rating_involved: number
  rating_language: number
  rating_passion: number
  reservation: any
  review_reply: any
  reviewer?: any
  direct_reservation?: any
  reviewer_name?: any
  review_date?: any
  anonymous_review_author?: string
  post_slug?: string
  reviewable?: any
  reviewable_type?: string
}
const AvatarContent: React.VFC<{ review: any }> = ({ review }) => {
  const AvatarImageContent = () => {
    if (review.reviewer) {
      return (
        <span className="Avatar_Image">
          <AvatarImage avatarURL={review.reviewer.avatar_url} size={60} />
        </span>
      )
    }
    return <AvatarImage avatarURL={`${constants.ASSET_HOST}/images/no-avatar.svg`} size={60} />
  }

  const reviewerName = React.useMemo(() => {
    return (
      review.reviewer?.username ||
      review.direct_reservation?.guest_name ||
      review.anonymous_review_author ||
      null
    )
  }, [review])

  return (
    <Avatar className="Avatar">
      <AvatarImageContent />
      <div className="Avatar_Info">
        {reviewerName && <h4>{reviewerName}</h4>}
        {review.review_date && <span>{review.review_date}</span>}
      </div>
    </Avatar>
  )
}
const Index: React.FC<IProps> = props => {
  const { data, pagination } = postService.getDataFromJson(props.reviews.records)
  const [reviews, setReviews] = React.useState(data)
  const { data: user } = utilService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={user}>
      <Panel
        marginType="dashboard"
        title={I18n.t('generic.user_reviews_list', { username: user.username })}
      >
        <Headline>
          <div className="count">
            <Score score={user.average_review} />
            {user.review_count && (
              <span className="review_count">
                ({I18n.t('review.review_count', { count: user.review_count })})
              </span>
            )}
          </div>
        </Headline>
        <Inner>
          {reviews.map((review: IReview, index) => {
            return (
              <ReviewWrapper key={index}>
                <AvatarContent review={review} />
                <div className="Review">
                  <Score score={Math.round(review.rating / 2)} />
                  {review.reviewable && review.reviewable_type === 'Post' && (
                    <div className="TourTitle">
                      <a
                        href={`/posts/${review.reviewable.family_owner_slug ||
                          review.reviewable.slug}`}
                      >
                        {review.reviewable.name}
                      </a>
                    </div>
                  )}
                  <a className="body" href={review.post_slug}>
                    {review.body}
                  </a>
                </div>
              </ReviewWrapper>
            )
          })}

          {pagination && (
            <Pagination
              onChangePageHandler={page => (location.href = `${location.pathname}?page=${page}`)}
              currentPage={pagination.current_page}
              prevPage={pagination.prev_page}
              nextPage={pagination.next_page}
              totalCount={pagination.total_count}
              totalPages={pagination.total_pages}
            />
          )}
        </Inner>
      </Panel>
    </SidebarLayout>
  )
}
const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: auto;
  padding: 24px 0;
`

const ReviewWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border: 1px solid ${constants.COLORS.divider};
  padding: 10px;

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;
    border: none;
    border-bottom: 1px solid ${constants.COLORS.divider};
  }

  .Review {
    display: flex;
    flex-direction: column;
    .ReviewScore {
      display: flex;
      flex-direction: row;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;

      align-items: center;
    }
    .TourTitle {
      margin-top: 0.5em;
      font-weight: bold;
    }
    .body {
      display: block;
      color: ${constants.COLORS.black}
      margin-top: 0.5em;
      font-size: 14px;
      width: 100%;
    }
  }
`
const Headline = styled.div`
  .count {
    display: flex;
    align-items: center;
    font-size: 10px;
  }
  .review_count {
    margin-left: 10px;
  }
`
const Avatar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin: 5px;
  width: 250px;
  .Avatar {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .Avatar_Info {
    flex: 1;

    h4 {
      font-size: 16px;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > span {
      display: block;
      font-size: 0.8em;
      color: gray;
    }
  }
`

export default Index
